import React from 'react';

const Down = (props) => {
  const fill = props.fill || '#C4C4C4';

  return (
    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" {...props}>
      <path
        d="M6.99788 6.95501C6.98834 6.81352 6.93269 6.67838 6.83889 6.57186L1.11494 0.21246C0.87962 -0.0498648 0.475767 -0.0721226 0.213419 0.161585C-0.0489281 0.396883 -0.0711891 0.800704 0.162539 1.06303C0.164129 1.06462 0.164132 1.06462 0.165722 1.06621L5.50807 6.99953L0.165722 12.9328C-0.0711854 13.1936 -0.0521106 13.5974 0.210237 13.8343C0.470995 14.0712 0.874848 14.0521 1.11176 13.7898C1.11335 13.7882 1.11335 13.7882 1.11494 13.7866L6.83889 7.4272C6.95336 7.29842 7.01219 7.12831 6.99788 6.95501Z"
        fill={fill}
      />
    </svg>
  );
};

export default Down;
